import { useEffect, useState } from "react";

import AllDetailsSidebar from "./AllDetailsSidebar/AllDetailsSidebar";
import Backdrop from "../../../../../Components/UI/Backdrop/Backdrop";
import Content from "./Content/Content";
import DetectionSandboxSubmit from "../DetectionDetailPopup/DetectionSandboxSubmit";
import SigmaMatchPanel from "./SigmaMatchPanel/SigmaMatchPanel";
import ThreatsTable from "./ThreatsTable/ThreatsTable";

import "./styles.scss";

export default function LinkedSidebarContent({
  className = "thunter-additional-data border",
  sections = [],
  onSelectedItemChange,
  defaultActiveTabId,
  actionButton,
  progressBackdrop,
  loading,
  error,
  absoluteBackdropWhileLoading = true,
}) {
  const [selectedItem, setSelectedItem] = useState();

  useEffect(() => {
    const s = sections.find((sec) => (sec.items?.length ?? 0) > 0) || sections[0];
    const firstItem = s?.items?.[0] ?? null;

    if (firstItem) {
      setSelectedItem(firstItem);
    }
  }, [sections, setSelectedItem]);

  const setSelected = (item) => {
    setSelectedItem(item);
    onSelectedItemChange?.(item);
  };

  const renderContent = () => {
    if (loading) return null;

    if (error) {
      return (
        <div className="thunter-additional-data__content">
          <div className="thunter-additional-data__content__error">Could not fetch data!</div>
        </div>
      );
    }

    if (!selectedItem) {
      return (
        <div className="thunter-additional-data__content">
          <div className="thunter-additional-data__content__error">No data</div>
        </div>
      );
    }

    return (
      <Content item={selectedItem} rightHeader={<DetectionSandboxSubmit item={selectedItem} />}>
        {selectedItem.engine !== "sigma" ? (
          <ThreatsTable threats={selectedItem.threats || []} />
        ) : (
          <SigmaMatchPanel match={selectedItem.threats?.[0] || {}} />
        )}
      </Content>
    );
  };

  return (
    <div className={className}>
      <AllDetailsSidebar
        className="thunter-additional-data__sidebar"
        sections={sections}
        selectedItem={selectedItem}
        onSelect={setSelected}
        actionButton={actionButton}
        backdrop={progressBackdrop}
      />

      {renderContent()}

      <Backdrop show={!!loading} absolute={absoluteBackdropWhileLoading} />
    </div>
  );
}
